export default __webpack_public_path__ + "static/media/m_navBannerImg0.d449596e.png";